<template>

  <div>
    <div class="header">
      <div class="header-photo">
        <CandidatePhoto />
      </div>
      <div class="header-title">
        <div v-if="!editName">
          <h3>
            <i
              v-if="permissions.includes('manage_candidates')"
              class="fas fa-pencil-alt"
              :title="$t('Edit')"
              @click.stop="editName=true"
              style="cursor: pointer; float: right; font-size: 13px; margin: 0 0 0.5em 0.5em">
              </i>
            {{ candidate.name }}
          </h3>
          <h5 v-if="candidate.headline">{{ candidate.headline }}</h5>
        </div>
        <CandidateNameForm
          v-if="editName"
          :initCandidate="candidate"
          @cancel="editName=false"
          @saved="editName=false"
          class="mb-3" />
        
        <CandidateTag />
      </div>
      <div class="header-rating text-nowrap" align="right">
        <CandidateConsent
          v-if="gdprEnable"
          class="mb-2" />
        <CandidateDiversity
          v-if="diversityEnable"
          class="mb-2" />
        <CandidateFollow class="mb-2" />
        <CandidateRating />
      </div>
    </div>

    <CandidateNextEvent
      v-if="candidate.next_event"
      :next_event="candidate.next_event" />

  </div>

</template>

<script>
import CandidatePhoto from './CandidatePhoto'
import CandidateTag from './CandidateTag'
import CandidateNameForm from './CandidateNameForm'
import CandidateFollow from './CandidateFollow'
import CandidateConsent from './CandidateConsent'
import CandidateDiversity from './CandidateDiversity'
import CandidateRating from './CandidateRating'
import CandidateNextEvent from './CandidateNextEvent'

export default {
  name: 'Candidate',
  components: {
    CandidatePhoto,
    CandidateTag,
    CandidateNameForm,
    CandidateFollow,
    CandidateConsent,
    CandidateDiversity,
    CandidateRating,
    CandidateNextEvent
  },
  props: [
  ],
  data () {
    return {
      editName: null
    }
  },
  computed: {
    gdprEnable () {
      const account = this.$store.getters.getAccount
      return account.settings.gdpr
    },
    diversityEnable () {
      const account = this.$store.getters.getAccount
      return account.settings.diversity
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
.header{
  background: rgba(0,0,0,0.8);
  color: rgba(255,255,255,0.8);
  display: flex;
  padding: 1rem;
}
  .header > .header-photo{
    margin: 0 1em 0 0; 
  }
  .header > .header-title {
    margin: 0 1em 0 0;
  }
  .header > .header-rating {
    margin-left: auto;
  }

@media (max-width : 576px) {
  .header{
    flex-wrap: wrap;
  }
    .header > .header-photo{
      order: 0;
    }
    .header > .header-title {
      flex: 1 576px;
      order: 2;
      margin: 1em 0 0 0;
      padding: 1em 0 0 0;
      border-top: 1px solid rgba(255,255,255,0.2);
    }
    .header > .header-rating {
      order: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidateHeader.vue